module.exports = __webpack_public_path__ + "img/about-ch4-sectors-urban-water.79ed0206.png";